export const F1 = [
    "Aucune expérience",
    "Débutant",
    "Expérience de base",
    "Expérimenté",
    "Expert"
];

export const F2 = [
    "Aucune expérience(DEEPSEA, COMAP, DEIF, ETC.)",
    "Débutant(DEEPSEA, COMAP, DEIF, ETC.)",
    "Expérience de base(DEEPSEA, COMAP, DEIF, ETC.)",
    "Expérimenté(DEEPSEA, COMAP, DEIF, ETC.)",
    "Expert(DEEPSEA, COMAP, DEIF, ETC.)"
];

export const F3 = [
    "Aucune expérience (BASLER, UNITROL, ETC.)",
    "Débutant (BASLER, UNITROL, ETC.)",
    "Expérience de base (BASLER, UNITROL, ETC.)",
    "Expérimenté (BASLER, UNITROL, ETC.)",
    "Expert (BASLER, UNITROL, ETC.)"
];

export const F4 = [
    "Oui",
    "Non",
    "Externalisation"
];

export const F5 = [
    "Jusqu'à 200 kva",
    "Jusqu'à 500 kva",
    "Jusqu'à 1000 kva",
    "Jusqu'à 1500 kva",
    "Jusqu'à 2000 kva",
    "Jusqu'à 2500 kva",
    "Jusqu'à 3000 kva",
    "Aucune limite"
];

export const F6 = [
    "Pas de service sur place",
    "Jusqu'à 500 km",
    "Jusqu'à 1000 km",
    "Plus de 1000 km (pas de limite)"

];

export const F7 = [
    "Aucune",
    "Oui, de 1 à 5",
    "Oui, de 6 à 10",
    "Oui, plus de 10"
];

export const F8 = [
    "Oui",
    "Non"
];

export const F9 = [
    "Oui, avec le laser",
    "Oui, avec le comparateur à cadran",
    "Oui avec un autre outil",
    "Non"
];
export const F10 = [
    "Oui, service confirmé",
    "Non disponible"
];

export const F11 = [
    "Approuvé",
    "Non approuvé"

];

export const F12 = [
    "Null",
    "Pauvre",
    "De base",
    "Bon",
    "Excellent"
];
export const F13 = [
    "Service",
    "Meccalte"
];

export const FArea = [
    "Europe - Italie",
    "Europe - Espagne",
    "Europe - UK / EIRE",
    "Europe - Allemagne",
    "Europe - France",
    "Europe - Russie",
    "Europe - Autres pays",
    "Afrique",
    "Amérique du Nord",
    "Amérique centrale",
    "Amérique du Sud",
    "moyen-Orient",
    "Extrême-Orient - Inde",
    "Extrême-Orient"
]


export const FRNotes = [
    "Le bouton de droite remplit automatiquement le champ en fonction des informations répertoriées ci-dessus. Si ces informations ne sont pas reconnues, saisissez manuellement les coordonnées, la latitude et la longitude, séparées par une virgule <br> (exemple: 45.6515661 , 11.8564252, puis latitude puis un espace, puis une virgule, puis un espace et enfin la longitude).",
    "Techniciens, ingénieurs pour intervention sur site",
    "Situation des filiales, remplissez un questionnaire SPQ supplémentaire pour chaque établissement/filiale",
    "Nombre approximatif de réparations en atelier et d'interventions sur site effectuées pour Mecc Alte",
    "Nombre de réparations en atelier et d'interventions sur site effectuées pour meccalte au cours des 12 derniers mois, préciser la période",
    "Taux horaire standard en atelier",
    "Taux horaire standard pour l'activité sur site",
    "Date de visite/d'audit, indiquer les visiteurs de meccalte",
    "Commenter les éventuels avantages ou inconvénients des autres fabricants d'alternateurs",
    "Commenter les éventuels avantages ou inconvénients des autres fabricants de groupes électrogènes",
    "Sélectionnez le niveau concernant vos compétences en matière de communication",
    "Sélectionnez oui pour confirmer la disponibilité de ce service"
];